
































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { pricingModule } from '@/store/modules/modulePricing';
import {
  Days,
  OfferUnitPriceMap,
  OppPricingAmount,
  TaxesAndFees,
} from '@/api/inventory/InventoryModels';
import {
  requiredFieldRules,
  optionalStartDateBeforeEndDateRules,
} from '@/utils/validation-rules';
import { productModule } from '@/store/modules/moduleProduct';
import { optionModule } from '@/store/modules/moduleOption';
import { constants } from '@/utils/constants';
import RdmCollapsableCard from '@/components/common/card/RdmCollapsableCard.vue';
import RdmPublishButton from '@/components/common/button/RdmPublishButton.vue';
import { travelerTypeModule } from '@/store/modules/moduleTravelerType';
import faker from 'faker';
import { format } from 'date-fns';
import { companyModule } from '@/store/modules/moduleCompany';
import _ from 'lodash';
import { appModule } from '@/store/modules/moduleApp';
import {
  centsToDollars,
  concatTaxesToPrice,
  dollarsToCents,
  handleKeyDownOnlyNumeric,
  roundAmount,
} from '@/utils/helpers';
import { httpModule } from '@/store/modules/moduleHttp';
import { scheduleModule } from '@/store/modules/moduleSchedule';
import {
  GRSchedule,
  Schedule,
  TimeSlot,
  OfferPricing,
  Fee,
  OfferPricingList,
  OptionUnitPrice,
  UnitPriceAmount,
  FeesPriceAmount,
} from '@/models';
import { taxesAndFeesModule } from '@/store/modules/moduleTaxAndFees';
import { offerModule } from '@/store/modules/moduleOffer';
import OfferCreateTaxes from '@/components/offer/create/OfferCreateTaxes.vue';

@Component({
  components: {
    RdmCollapsableCard,
    RdmPublishButton,
    OfferCreateTaxes,
  },
  props: {
    close: {
      type: Function,
      default: null,
    },
  },
})
export default class OfferCreatePricingModal extends Vue {
  private showTaxes = false;
  private selectedCurrency = 'USD';
  private startDateMenu = false;
  private endDateMenu = false;
  private optionalStartBeforeEndField = optionalStartDateBeforeEndDateRules;
  private dayTimeExpand = [0];
  private requiredField = requiredFieldRules;
  private dateFrom = '';
  private dateUntil = '';
  private allDaysSelected = true;
  private totalRetail = 0;
  private totalNet = 0;
  private offerPricings = [] as any;
  private validation = false;
  private routeToCreateOption = constants.routes.OPTION_LIST;
  private handleKeyDown = handleKeyDownOnlyNumeric;
  private addPricingActive = true;
  private selectedScheduleId = '';
  private priceName = '';
  private selectedTravelerTypesAll = [] as Array<string>;
  private selectedScheduleDays = [] as Array<TimeSlot>;
  private createPricingStep = 1;
  private offerPricing = {} as OppPricingAmount;
  private unitPricing = {} as OfferUnitPriceMap;
  private optionUnitPricing = {} as OfferUnitPriceMap;
  private createScheduleDialog = false;

  get Schedules() {
    return [
      scheduleModule.DefaultSchedule,
      ...productModule.ProductSchedules,
      ...optionModule.OptionSchedules,
    ];
  }

  get OfferPublished() {
    return pricingModule.OfferPublished;
  }

  get Schedule() {
    return scheduleModule.Schedule;
  }

  get Currency() {
    return taxesAndFeesModule.SelectedCurrency;
  }

  get Option() {
    return optionModule.Option;
  }

  get Product() {
    return productModule.Product;
  }

  get OfferPricing() {
    return pricingModule.OfferPricing;
  }

  get OfferPrices() {
    return pricingModule.OfferPricings;
  }

  get HasValidUnits() {
    const unitCount = this.offerPricings.length;
    if (unitCount === 0) {
      return false;
    }

    let isValid = true;

    this.offerPricings.forEach((u: any) => {
      if (isValid) {
        const valid = this.isValidUnitPrice(u);
        if (!valid) {
          isValid = false;
        }
      }
    });

    return isValid;
  }

  get Taxes() {
    const taxes = [] as Array<Fee>;
    taxesAndFeesModule.TaxesAndFees.map((tax) => {
      if (this.OfferPricing.fees) {
        this.OfferPricing.fees.map((item) => {
          if (tax.id === item.taxFeeId)
            taxes.push({
              ...tax,
              applicationOrder: item.applicationOrder,
            });
        });
      }
    });
    return taxes.sort((a, b) => a.applicationOrder - b.applicationOrder);
  }

  created() {
    scheduleModule.setSchedule({} as Schedule);
  }

  async mounted() {
    await httpModule.productSchedules(this.Product.id);
    await httpModule.optionSchedules(this.Option.id);
    this.$root.$on(constants.events.OFFER_CREATE_FORM_4, this.selectSingleElements);
  }

  destroyed() {
    this.$root.$off(constants.events.OFFER_CREATE_FORM_4);
  }

  closeModal() {
    this.dateFrom = '';
    this.dateUntil = '';
    this.selectedScheduleId = '';
    this.priceName = '';
    this.offerPricings = [];
    scheduleModule.setSchedule({} as Schedule);
    this.$props.close();
  }

  async changeSchedule() {
    const schedule = this.Schedules.find(
      (item) => item.id === this.selectedScheduleId,
    ) as GRSchedule;
    await httpModule.getSchedule(schedule.id);
    const today = format(new Date(), 'yyyy-MM-dd');
    const endDate = this.Schedule.validUntil ? this.Schedule.validUntil : today;
    this.dateFrom =
      this.Schedule.validFrom <= today && today <= endDate
        ? today
        : this.Schedule.validFrom || '';
    this.dateUntil = this.Schedule.validUntil || '';
    this.selectedScheduleDays = this.Schedule.timeSlots;
  }

  changeWeekDay(slots: Array<TimeSlot>, item: any) {
    item.selectedAll = !item.selectedAll;
    slots.map((itm: any) => (itm.editMode = item.selectedAll));
    this.checkIfAllSelected();
  }

  changeTimeSlot(slot: TimeSlot, item: any) {
    slot.editMode = !slot.editMode;
    const check = item.timeSlots.filter((item: any) => item.editMode === true);
    item.selectedAll = check.length === item.timeSlots.length;
    this.checkIfAllSelected();
  }

  changeAll() {
    if (this.allDaysSelected) {
      this.StructuredSchedule.map((item: any) => {
        item.selectedAll = false;
        item.timeSlots.map((slot: TimeSlot) => (slot.editMode = false));
      });
    } else if (!this.allDaysSelected) {
      this.StructuredSchedule.map((item: any) => {
        item.selectedAll = true;
        item.timeSlots.map((slot: TimeSlot) => (slot.editMode = true));
      });
    }
    this.checkIfAllSelected();
  }
  checkIfAllSelected() {
    const check = this.StructuredSchedule.filter((item: any) => {
      return item.selectedAll === true;
    });

    this.allDaysSelected = check.length === this.StructuredSchedule.length;
  }

  validate1Step() {
    this.validation = true;
    if (this.$refs?.form) {
      const form: any = this.$refs.form;
      const isValid = form.validate();
      if (isValid) {
        this.nextPricing();
      }
    }
  }

  validate2Step() {
    this.validation = true;
    if (this.$refs?.form) {
      const form: any = this.$refs.unitPriceForm;
      const isValid = form.validate();
      if (isValid) {
        this.addPricing();
      }
    }
  }

  isValidUnitPrice(unit: any) {
    return (
      (unit.net && _.isNumber(+unit.net) && _.toNumber(unit.net) >= 0) ||
      (unit.original && _.isNumber(+unit.original) && _.toNumber(unit.original) >= 0) ||
      (unit.retail && _.isNumber(+unit.retail) && _.toNumber(unit.retail) >= 0) ||
      unit.net === null ||
      unit.original === null ||
      unit.retail === null
    );
  }
  nextPricing() {
    this.configureStep2Data();
    this.offerPricings = this.selectedTravelerTypesAll.map((unit) => {
      const optionPrice = this.Option.unitPrices?.find(
        (item: OptionUnitPrice) => item.unitId === unit,
      );
      return {
        id: unit,
        retail: null,
        net: null,
        original: null,
        totalRetail: null,
        totalNet: null,
        totalOriginal: null,
        optionPrice: null,
        optionPriceRetail: centsToDollars(optionPrice?.amount?.retail) || null,
        optionPriceNet: centsToDollars(optionPrice?.amount?.net) || null,
        optionPriceOriginal: centsToDollars(optionPrice?.amount?.original) || null,
        taxPriceRetail: null,
        taxPriceNet: null,
        taxPriceOriginal: null,
      };
    });
    this.createPricingStep = 2;
  }

  onChangeRetail(unit: string) {
    const offerPricing = this.offerPricings.find((item: any) => item.id === unit);
    let retailPrice = Number(offerPricing.retail);
    const optionPrice = this.Option?.unitPrices?.find((u) => u.unitId === unit);
    const optionRetail = centsToDollars(optionPrice?.amount.retail) || 0;
    let taxesAmount = 0;

    if (optionPrice && optionPrice?.amount.retail) retailPrice += optionRetail;
    this.SelectedTnF.map(
      (tax: TaxesAndFees) => (taxesAmount += concatTaxesToPrice(tax, retailPrice)),
    );
    if (retailPrice !== null) retailPrice += taxesAmount;
    offerPricing.totalRetail = roundAmount(retailPrice);

    if (optionPrice?.amount.retail) {
      offerPricing.taxPriceRetail = roundAmount(
        retailPrice - (Number(offerPricing.retail) + optionRetail),
      );
    } else {
      offerPricing.taxPriceRetail = roundAmount(
        retailPrice - Number(offerPricing.retail),
      );
    }
  }

  onChangeNet(unit: string) {
    const offerPricing = this.offerPricings.find((item: any) => item.id === unit);
    let netPrice = Number(offerPricing.net);
    const optionPrice = this.Option?.unitPrices?.find((u) => u.unitId === unit);
    const optionNet = centsToDollars(optionPrice?.amount.net) || 0;
    let taxesAmount = 0;

    if (optionPrice && optionPrice.amount.net) netPrice += optionNet;
    this.SelectedTnF.map(
      (tax: TaxesAndFees) => (taxesAmount += concatTaxesToPrice(tax, netPrice)),
    );
    if (netPrice !== null) netPrice += taxesAmount;
    offerPricing.totalNet = roundAmount(netPrice);

    if (optionPrice?.amount.net) {
      offerPricing.taxPriceNet = roundAmount(
        netPrice - (Number(offerPricing.net) + optionNet),
      );
    } else {
      offerPricing.taxPriceNet = roundAmount(netPrice - Number(offerPricing.net));
    }
  }

  onChangeOriginal(unit: string) {
    const offerPricing = this.offerPricings.find((item: any) => item.id === unit);
    let originalPrice = Number(offerPricing.original);
    const optionPrice = this.Option?.unitPrices?.find((u) => u.unitId === unit);
    const optionOriginal = centsToDollars(optionPrice?.amount.original) || 0;
    let taxesAmount = 0;

    if (optionPrice && optionPrice.amount.original) originalPrice += optionOriginal;
    this.SelectedTnF.map(
      (tax: TaxesAndFees) => (taxesAmount += concatTaxesToPrice(tax, originalPrice)),
    );
    if (originalPrice !== null) originalPrice += taxesAmount;

    offerPricing.totalOriginal = roundAmount(originalPrice);

    if (optionPrice?.amount.original) {
      offerPricing.taxPriceOriginal = roundAmount(
        originalPrice - (Number(offerPricing.original) + optionOriginal),
      );
    } else {
      offerPricing.taxPriceOriginal = roundAmount(
        originalPrice - Number(offerPricing.original),
      );
    }
  }

  async addPricing() {
    const endDt = this.dateUntil;
    const pricing = {
      id: faker.datatype.uuid(),
      name: this.priceName,
      fees: this.SelectedTnF.map((fee: TaxesAndFees, i: number) => {
        return {
          taxFeeId: fee.id,
          applicationOrder: i,
        };
      }),
      offerId: this.SelectedOffer.id,
      scheduleId: this.selectedScheduleId,
      timeSlots: this.selectedScheduleDays.filter((item) => item.editMode === true),
      unitPrices: this.offerPricings.map((unit: any) => {
        const amount = {} as UnitPriceAmount;
        const fee = {} as FeesPriceAmount;

        if (unit.totalRetail !== null) {
          amount.retail = dollarsToCents(unit.totalRetail);
          if (this.SelectedTnF.length) {
            fee.retail = dollarsToCents(unit.taxPriceRetail);
          }
        }
        if (unit.totalNet !== null) {
          amount.net = dollarsToCents(unit.totalNet);
          if (this.SelectedTnF.length) {
            fee.net = dollarsToCents(unit.taxPriceRetail);
          }
        }
        if (unit.totalOriginal !== null) {
          amount.original = dollarsToCents(unit.totalOriginal);
          if (this.SelectedTnF.length) {
            fee.original = dollarsToCents(unit.taxPriceOriginal);
          }
        }
        amount.currency = this.selectedCurrency;
        amount.includedFees = [];
        if (Object.keys(fee).length) {
          fee.name = unit.taxName;
          amount.includedFees.push(fee);
        }
        return {
          unitId: unit.id,
          amount: amount,
        };
      }),
      validFrom: this.dateFrom,
      validUntil: _.isEmpty(endDt) ? null : endDt,
    } as OfferPricing;
    pricingModule.setOfferPricings({} as OfferPricingList);
    httpModule
      .updateOfferPricing(pricing)
      .then(async () => {
        this.closeModal();
        offerModule.setProductOfferPricingSetLoading(true);
        _.delay(async () => {
          await httpModule.getOffer({ offerId: this.$route.params.id });
          offerModule.setProductOfferPricingSetLoading(false);
        }, 5000);
      })
      .catch();
  }

  resetState() {
    this.priceName = '';
    this.dateFrom = '';
    this.dateUntil = '';
    this.selectedTravelerTypesAll = [] as Array<string>;
    this.selectedScheduleDays = [] as Array<TimeSlot>;
    this.unitPricing = {} as OfferUnitPriceMap;
    this.optionUnitPricing = {} as OfferUnitPriceMap;
    this.createPricingStep = 1;
    this.addPricingActive = false;
    this.selectSingleElements();
  }

  configureStep2Data() {
    if (this.selectedTravelerTypesAll && Array.isArray(this.selectedTravelerTypesAll)) {
      const productId = this.SelectedOfferProductId;
      const optionId = this.SelectedOfferOptionId;
      this.selectedTravelerTypesAll.forEach((t) => {
        this.unitPricing[t] = {
          unitId: t,
          productId: productId,
          amount: {
            net: undefined,
            original: undefined,
            retail: undefined,
          } as OppPricingAmount,
        };
        this.optionUnitPricing[t] = {
          unitId: t,
          productId: productId,
          optionId: optionId && optionId.length > 0 ? optionId : undefined,
          amount: {
            net: undefined,
            original: undefined,
            retail: undefined,
          } as OppPricingAmount,
        };
      });
    }
  }

  selectSingleElements() {
    if (
      Array.isArray(this.TravelerTypes) &&
      this.TravelerTypes.length === 1 &&
      this.TravelerTypes[0].id
    ) {
      this.selectedTravelerTypesAll.push(this.TravelerTypes[0].id);
    }

    if (Array.isArray(this.ScheduleViews) && this.ScheduleViews.length === 1) {
      this.selectedScheduleId = this.ScheduleViews[0].id;
    }
  }

  getTravelerTypeName(id: string): string {
    const traveler = this.TravelerTypes.find((t) => t.id === id);
    if (traveler && traveler.internalName) {
      return traveler.internalName;
    }
    return '';
  }

  toggleAllTravelerTypes() {
    this.$nextTick(() => {
      if (this.selectedTravelerTypesAll.length === this.TravelerTypes.length) {
        this.selectedTravelerTypesAll = [];
      } else {
        const typeIds = [] as Array<string>;
        this.TravelerTypes.forEach((t) => typeIds.push(t.id || ''));
        this.selectedTravelerTypesAll = typeIds.slice();
      }
    });
  }

  goToScheduleCreate() {
    this.createScheduleDialog = false;
    if (this.Product.id && this.Product.id.length > 0) {
      this.$router
        .push({
          name: constants.routes.PRODUCT_DETAILS,
          params: { id: this.Product.id },
          hash: '#schedule',
        })
        .catch();
    } else {
      this.$router.push({ name: this.routeToCreateOption }).catch();
    }
  }

  get Loading() {
    return pricingModule.Loading;
  }

  get StructuredSchedule() {
    if (!this.Schedule.id || this.Schedule.timeSlots === null) return [];
    const days = [] as Array<string>;
    let timeSlots = [] as any;
    const structured = [] as any;
    this.Schedule.timeSlots.map((item) => {
      if (!days.includes(item.weekday)) {
        days.push(item.weekday);
      }
    });
    days.map((day) => {
      this.Schedule.timeSlots.map((item) => {
        if (item.weekday === day) {
          item.editMode = true;
          timeSlots.push(item);
        }
      });
      structured.push({
        weekday: day,
        selectedAll: true,
        timeSlots: timeSlots,
      });
      timeSlots = [];
    });
    return structured;
  }

  get Form4Valid() {
    return pricingModule.CreateForm4Valid;
  }

  set Form4Valid(valid: boolean) {
    pricingModule.setCreateForm4Valid(valid);
  }

  get Form5Valid() {
    return pricingModule.CreateForm5Valid;
  }

  set Form5Valid(valid: boolean) {
    pricingModule.setCreateForm5Valid(valid);
  }

  get SelectedOfferProductId() {
    return pricingModule.SelectedOfferProductId;
  }

  get SelectedOfferOptionId() {
    return pricingModule.SelectedOfferOptionId;
  }

  get GroupedSchedules() {
    return productModule.GroupedAvailabilitySchedules;
  }

  get ScheduleViews() {
    const views = productModule.ScheduleViews.filter(
      (scheduleViews) => scheduleViews.productId === pricingModule.SelectedOfferProductId,
    );
    if (views.length === 0) {
      const today = format(new Date(), 'yyyy-MM-dd');
      views.push({
        id: faker.datatype.uuid(),
        schedules: [
          {
            id: faker.datatype.uuid(),
            startTime: '00:00',
            endTime: '23:59',
            daysOfWeek: [
              Days.Sunday,
              Days.Monday,
              Days.Tuesday,
              Days.Wednesday,
              Days.Thursday,
              Days.Friday,
              Days.Saturday,
            ],
            productId: pricingModule.SelectedOfferProductId,
            name: 'Default',
            validFrom: today,
            org: companyModule.Organization?.ID || '',
          },
        ],
        scheduleName: 'Default',
        productId: pricingModule.SelectedOfferProductId,
        validFrom: today,
      });
    }

    return views;
  }

  get TravelerTypes() {
    return pricingModule.TravelerTypesForOffer;
  }

  get TravelerTypesPlusAll() {
    return [{ id: 'ALL', internalName: 'ALL' }, ...travelerTypeModule.TravelerTypes];
  }

  get TravelerTypeSelectIcon() {
    if (this.selectedTravelerTypesAll.length === this.TravelerTypes.length) {
      return 'mdi-close-box';
    }
    if (
      this.selectedTravelerTypesAll.length > 0 &&
      this.selectedTravelerTypesAll.length < this.TravelerTypes.length
    ) {
      return 'mdi-minus-box';
    }
    return 'mdi-checkbox-blank-outline';
  }

  get SelectedProduct() {
    return pricingModule.SelectedOfferProduct;
  }

  get SelectedOption() {
    return pricingModule.SelectedOfferOption;
  }

  get OfferUnitPrices() {
    return pricingModule.UnitPricingList;
  }

  get SelectedOffer() {
    return pricingModule.Offer;
  }

  get SelectedTnF(): Array<TaxesAndFees> {
    return pricingModule.SelectedTaxesAndFees;
  }

  get Currencies() {
    return appModule.Codes?.currency || [];
  }

  get ProductSchedule() {
    return productModule.ProductSchedules;
  }

  get OptionSchedule() {
    return optionModule.OptionSchedules;
  }

  get DateFromFormatted() {
    if (this.dateFrom && this.dateFrom.length > 0 && _.isDate(new Date(this.dateFrom))) {
      const date = new Date(this.dateFrom);
      return format(date, 'MM/dd/yyyy');
    }
    return '';
  }

  get DateUntilFormatted() {
    if (
      this.dateUntil &&
      this.dateUntil.length > 0 &&
      _.isDate(new Date(this.dateUntil))
    ) {
      const date = new Date(this.dateUntil);
      return format(date, 'MM/dd/yyyy');
    }
    return '';
  }

  private formattedCurrencies() {
    return this.Currencies.map((item: any) => {
      return { ...item, itemText: `${item.description} (${item.value})` };
    });
  }
}
